import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  imports: [TranslatePipe],
  selector: 'iot-platform-maps-map-spinner',
  templateUrl: './map-spinner.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./map-spinner.component.scss']
})
export class MapSpinnerComponent {
  loading = input<boolean>(false);
  label = input<string>();
}
